export default "__VITE_ASSET__DfKwBsBa__"